import { ListItemButton, ListItemIcon, Text } from '@shared/components';

import { TooltipMenu } from '../tooltip-menu';

import UserAvatarIcon from './user-avatar-icon';

export interface UserMenuItemProps {
  displayName?: string;
  minified?: boolean;
}

export default function UserMenuItem(props: Readonly<UserMenuItemProps>) {
  const { displayName = 'Guest User', minified: isMinified = false } = props;

  return (
    <TooltipMenu title={isMinified ? displayName.trim() : ''}>
      <ListItemButton
        component='li'
        disableRipple
        sx={{ '&:hover': { bgcolor: 'inherit', cursor: 'default' } }}
      >
        <ListItemIcon>
          <UserAvatarIcon />
        </ListItemIcon>
        <Text>{displayName.trim()}</Text>
      </ListItemButton>
    </TooltipMenu>
  );
}
